<mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onInputChange($event)"
    (blur)="onBlur()"
    [matAutocomplete]="addressAuto"
    [disabled]="disabled"
    type="text"/>
  <mat-icon matSuffix>search</mat-icon>
  <mat-autocomplete #addressAuto="matAutocomplete">
    <mat-option
      *ngFor="let prediction of predictions"
      [value]="prediction.label"
      (onSelectionChange)="$event.isUserInput && onSelect(prediction)">
      {{ prediction.label }}
    </mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>
